interface ConvertToCurrencyProps {
    cents: number;
    locale?:
        | "en-US"
        | "en-GB"
        | "nl-NL"
        | "de-DE"
        | "fr-FR"
        | "it-IT"
        | "es-ES"
        | "pt-PT";
    currency?: "EUR" | "USD" | "GBP";
    style?: "currency" | "decimal" | "percent";
}

function convertToCurrency({
    cents,
    currency = "EUR",
    locale,
    style = "currency",
}: ConvertToCurrencyProps): string {
    const usableLocale =
        locale ?? document.documentElement.dataset.icuLocale ?? "nl-NL";

    return Intl.NumberFormat(usableLocale, {
        style,
        currency,
    }).format(cents / 100);
}

export default convertToCurrency;
